/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FileTypeTextIcon32Regular = forwardRef('FileTypeTextIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M10 12a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2h-4v9a1 1 0 1 1-2 0v-9h-4a1 1 0 0 1-1-1Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 7.5A5.5 5.5 0 0 1 9.5 2h8.726a4 4 0 0 1 2.829 1.172l5.773 5.773A4 4 0 0 1 28 11.774V24.5a5.5 5.5 0 0 1-5.5 5.5h-13A5.5 5.5 0 0 1 4 24.5v-17ZM9.5 4A3.5 3.5 0 0 0 6 7.5v17A3.5 3.5 0 0 0 9.5 28h13a3.5 3.5 0 0 0 3.5-3.5V11.774a2 2 0 0 0-.586-1.414L19.64 4.586A2 2 0 0 0 18.226 4H9.5Z" })));
});
